import React from 'react';
import { Link } from 'react-router-dom';
import Eupraxia_logo from "../../assets/Images/footer-1.png"
import Elogo from "../../assets/Images/favicon.png"
import { FaLinkedin } from 'react-icons/fa';
import './Footer.css'; // Import the CSS file

const Footer = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="left-div">
                    <Link to="/">
                        <img className="Eupraxia_lg" src={Eupraxia_logo} alt='Eupraxia' />
                    </Link>
                </div>
                <div className="right-div">
                    <div className="grid-item"><a href="/careers">Careers</a></div>
                    <div className="grid-item"><Link to="/ContactUs">Contact Us</Link></div>
                </div>
            </div>
            <hr className="footer-line" />
            © 2026 Eupraxia Group.
Eupraxia Centre for Clinical Excellence LLP (INDIA) and Eupraxia Life Sciences LLC (USA).
All Rights Reserved.
            <div className="footer-bottom">
                <a href="https://www.linkedin.com/company/eupraxia-group" target="_blank" rel="noopener noreferrer">
                    <FaLinkedin className="linkedin-icon" />
                </a>
            </div>
        </footer>
    );
};

export default Footer;
